import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class YearService {

  constructor() {}

  getYear() {
    let data = sessionStorage.getItem('spareVehicleDetails');
    return data;
  }
  
}
